class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    document.body.removeEventListener('click', this.onBodyClickEvent);
    const done = () => {
      this.detailsContainer.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    };
    // MA: the panel lifts away and the dim fades out on the site's sheet curve, instead of vanishing
    const panel = this.detailsContainer.querySelector('.search-modal');
    if (!panel || !this.isOpen() || !panel.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return done();
    if (this.closing) return;
    this.closing = true;
    const opts = { duration: 280, easing: 'cubic-bezier(.32,.72,0,1)', fill: 'forwards' };
    const overlay = this.detailsContainer.querySelector('.modal-overlay');
    panel.animate([{ opacity: 0, transform: 'translateY(-12px)' }], opts).finished.then(() => {
      done();
      [panel, overlay].forEach((el) => el && el.getAnimations({ subtree: true }).forEach((a) => a.cancel()));
      this.closing = false;
    });
    try {
      overlay && overlay.animate([{ opacity: 0 }], { ...opts, pseudoElement: '::after' });
    } catch (e) {} // older browsers: the dim simply goes with the panel
  }
}

customElements.define('details-modal', DetailsModal);
